import React from 'react'

import { Fieldset } from '@fourthwall/components'

import { ImageFields } from '../../../../../Post/modules/ImageFields'

type Props = {
  imageFieldName: string
  imageResourceIdFieldName: string
  image?: string
}

export const ImageFieldsComponent = ({
  imageFieldName,
  imageResourceIdFieldName,
  image,
}: Props) => {
  return (
    <Fieldset.Row>
      <Fieldset.Item>
        <ImageFields
          imageFieldName={imageFieldName}
          imageResourceIdFieldName={imageResourceIdFieldName}
          image={image}
        />
      </Fieldset.Item>
    </Fieldset.Row>
  )
}
